import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { api, apiError, fmtDate } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { PageHeader } from "./AdminLayout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Profile() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ current_password: "", new_password: "" });
    const [sessions, setSessions] = useState([]);

    useEffect(() => {
        api.get("/auth/sessions").then((r) => setSessions(r.data)).catch(() => {});
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        try {
            await api.post("/auth/change-password", form);
            toast.success("Mot de passe modifié. Toutes vos sessions ont été révoquées, reconnectez-vous.");
            setTimeout(() => navigate("/connexion"), 1500);
        } catch (err) {
            toast.error(apiError(err));
        }
    };

    return (
        <div data-testid="admin-profile">
            <PageHeader title="Mon compte" subtitle={`${user?.email} — rôle : ${user?.role}`} />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-4xl">
                <form onSubmit={submit} className="rounded-2xl bg-white border border-gold/25 p-6 shadow-sm space-y-4">
                    <h2 className="font-heading font-bold text-forest">Changer mon mot de passe</h2>
                    <div><Label>Mot de passe actuel</Label><Input type="password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="current-password" /></div>
                    <div><Label>Nouveau mot de passe (10 caractères min.)</Label><Input type="password" minLength={10} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="new-password" /></div>
                    <Button type="submit" className="bg-forest text-cream" data-testid="change-password-submit">Modifier</Button>
                </form>
                <div className="rounded-2xl bg-white border border-gold/25 p-6 shadow-sm">
                    <h2 className="font-heading font-bold text-forest mb-4">Mes sessions actives</h2>
                    <div className="space-y-2">
                        {sessions.map((s, i) => (
                            <div key={i} className="text-xs bg-cream-subtle rounded-lg p-3" data-testid={`session-${i}`}>
                                <p className="text-forest font-medium">{s.user_agent?.slice(0, 70) || "Appareil inconnu"} {s.current && <span className="text-gold">(session actuelle)</span>}</p>
                                <p className="text-pineneedle mt-1">Dernière activité : {fmtDate(s.last_seen_at)}</p>
                            </div>
                        ))}
                        {sessions.length === 0 && <p className="text-sm text-pineneedle">Aucune session active.</p>}
                    </div>
                </div>
            </div>
        </div>
    );
}
